import { ArdoqId } from '@ardoq/api-types';
import { componentInterface } from '@ardoq/component-interface';
import { referenceInterface } from '@ardoq/reference-interface';
import { uniq } from 'lodash';
import { workspaceInterface } from '@ardoq/workspace-interface';

export const collectRelatedComponents = () =>
  componentInterface.getAllComponents();

export const collectRelatedReferences = () =>
  referenceInterface.getStubReferencesWithTypeName();

export const collectComponentTypeNamesFromWorkspaces = (
  workspaceIds: ArdoqId[]
): string[] => {
  const componentTypeNames = workspaceIds.flatMap(workspaceId =>
    workspaceInterface.getComponentTypes(workspaceId).map(({ name }) => name)
  );
  return uniq(componentTypeNames);
};

export const collectReferenceTypeNamesFromWorkspaces = (
  workspaceIds: ArdoqId[]
): string[] => {
  const referenceTypeNames = workspaceIds.flatMap(workspaceId =>
    workspaceInterface.getReferenceTypes(workspaceId).map(type => type.name)
  );
  return uniq(referenceTypeNames);
};
